export function formatDateTime(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return `${new Intl.DateTimeFormat("tr-TR", { dateStyle: "medium", timeStyle: "short", hour12: false }).format(date)} · ${timezone}`;
}

export function formatRelative(value: string): string {
  const differenceMinutes = Math.round((new Date(value).getTime() - Date.now()) / 60_000);
  if (!Number.isFinite(differenceMinutes)) return value;
  return new Intl.RelativeTimeFormat("tr-TR", { numeric: "auto" }).format(
    differenceMinutes,
    "minute",
  );
}
